import { showModal, closeModal, modalFrame } from './modal';

interface ShortcutGroup {
  title: string;
  shortcuts: Array<{ keys: string; desc: string }>;
}

const GROUPS: ShortcutGroup[] = [
  {
    title: 'Navigation',
    shortcuts: [
      { keys: 'Ctrl+K', desc: 'Quick switcher' },
      { keys: 'Alt+\u2191/\u2193', desc: 'Switch channels' },
      { keys: 'Alt+Shift+\u2191/\u2193', desc: 'Switch servers' },
      { keys: 'Ctrl+,', desc: 'User settings' },
      { keys: 'Ctrl+Shift+M', desc: 'Toggle member list' },
    ],
  },
  {
    title: 'Messages',
    shortcuts: [
      { keys: 'Enter', desc: 'Send message' },
      { keys: 'Shift+Enter', desc: 'New line' },
      { keys: 'R', desc: 'Reply (hover a message)' },
      { keys: 'Escape', desc: 'Cancel reply / close popup' },
    ],
  },
  {
    title: 'Text Formatting',
    shortcuts: [
      { keys: 'Ctrl+B', desc: 'Bold' },
      { keys: 'Ctrl+I', desc: 'Italic' },
      { keys: '**text**', desc: 'Bold' },
      { keys: '*text*', desc: 'Italic' },
      { keys: '~~text~~', desc: 'Strikethrough' },
      { keys: '||text||', desc: 'Spoiler' },
      { keys: '`code`', desc: 'Inline code' },
      { keys: '```code```', desc: 'Code block' },
    ],
  },
  {
    title: 'Compose',
    shortcuts: [
      { keys: '@name', desc: 'Mention a user' },
      { keys: '#channel', desc: 'Link a channel' },
      { keys: '/command', desc: 'Slash command' },
    ],
  },
  {
    title: 'General',
    shortcuts: [
      { keys: '?', desc: 'Keyboard shortcuts (this panel)' },
    ],
  },
];

function esc(s: string): string {
  const el = document.createElement('div');
  el.textContent = s;
  return el.innerHTML;
}

export function openKeyboardShortcuts(): void {
  const body = GROUPS.map(g => `
    <div class="ks-group">
      <div class="ks-group-title">${esc(g.title)}</div>
      ${g.shortcuts.map(s => `
        <div class="ks-row">
          <span class="ks-keys">${s.keys.split('+').map(k => `<kbd class="ks-kbd">${esc(k.trim())}</kbd>`).join('<span class="ks-plus">+</span>')}</span>
          <span class="ks-desc">${esc(s.desc)}</span>
        </div>
      `).join('')}
    </div>
  `).join('');

  showModal(modalFrame('Keyboard Shortcuts', `<div class="ks-panel">${body}</div>`, ''));

  document.getElementById('modal-close')?.addEventListener('click', closeModal);
}
